import ClockFill from './ClockFill';

export default ClockFill;
